import React, { Suspense, lazy, createContext } from "react";
import { connect } from "react-redux";
import { fetchJSON } from "helpers/axios";
import axios from "axios";
import ContainerHeader from "components/ContainerHeader/index";
import IntlMessages from "util/IntlMessages";
import LoadingOverlay from "react-loading-overlay";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import { withStyles } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { Link } from "react-router-dom";
import GetAppIcon from "@material-ui/icons/GetAppTwoTone";
import { Cancel, WarningRounded } from "@material-ui/icons";
import Widget from "components/Widget/index";
import {
  Box,
  Step,
  Stepper,
  StepLabel,
  Paper,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  AppBar,
  Toolbar,
  Typography,
  Slide,
  Grid,
  Card,
  CardContent,
  Divider,
  Chip,
  LinearProgress,
  Avatar,
} from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import MaterialTable from "material-table";
import { tableIcons } from "../../../constants/Icons";
import SweetAlert from "react-bootstrap-sweetalert";
import { regStatus, userSignOut, updateApplicantData } from "actions/Auth";
import html2canvas from "html2canvas";
import GenericPdfDownloader from "./downloadPDF";
import Alert from "@material-ui/lab/Alert";
import CloseIcon from "@material-ui/icons/Close";
import ApplicantForm from "../../../components/ApplicantForm";
import xpress from "../../../assets/images/xpress.jpg";
import Rimta from "./img/remmita.jpeg";
import nomba from "../../../assets/images/nombaLogo.png";
import nombaWhite from "../../../assets/images/NombaWhite.png";
import monnifyWhite from "../../../assets/images/monnifyBGRemoved.png";
import monnify from "../../../assets/images/monnifyLogo.png";
import ScreeningExercise from "../../../components/ApplicantForm/screeningResult";
import { DSTPartTimeDepartmentId } from "constant/Constant";
const PaymentReceipt = lazy(() => import("./paymentReceipt"));
const SchoolFeeChart = lazy(() => import("./schoolFeeChart"));
const Acceptance = lazy(() => import("./acceptance"));
const AdmLetter = lazy(() => import("./AdmLetter"));
const DSTProvisionalAdmissionLetter = lazy(() => import("./DSTProvisionalAdmissionLetter"));
const Checkout = lazy(() => import("./checkout"));

window.html2canvas = html2canvas;

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

const DashboardContext = createContext();

// Enhanced custom styles with gradients and better visual appeal
const styles = (theme) => ({
  root: {
    width: "100%",
    padding: theme.spacing(2),
    background: "linear-gradient(135deg, #f5f7fa 0%, #e4e8eb 100%)",
    // minHeight: "100vh",
  },
  progressContainer: {
    margin: theme.spacing(3, 0),
  },
  stepCard: {
    marginBottom: theme.spacing(3),
    borderLeft: `6px solid ${theme.palette.primary.main}`,
    borderRadius: "12px",
    boxShadow: "0 4px 20px 0 rgba(0,0,0,0.12)",
    transition: "all 0.3s cubic-bezier(.25,.8,.25,1)",
    background: "linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%)",
    "&:hover": {
      transform: "translateY(-5px)",
      boxShadow: "0 7px 30px -10px rgba(0,0,0,0.2)",
    },
  },
  activeStep: {
    background:
      "linear-gradient(135deg, rgba(25,118,210,0.1) 0%, rgba(25,118,210,0.05) 100%)",
    borderLeft: `6px solid ${theme.palette.secondary.main}`,
  },
  completedStep: {
    background:
      "linear-gradient(135deg, rgba(46,125,50,0.1) 0%, rgba(46,125,50,0.05) 100%)",
    borderLeft: `6px solid ${theme.palette.success.main}`,
  },
  actionButton: {
    margin: theme.spacing(1),
    borderRadius: "8px",
    fontWeight: 600,
    textTransform: "none",
    padding: theme.spacing(1, 3),
    boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
    "&:hover": {
      boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
    },
  },
  statusChip: {
    marginLeft: theme.spacing(1),
    fontWeight: 600,
    borderRadius: "12px",
  },
  documentCard: {
    margin: theme.spacing(2, 0),
    transition: "all 0.3s ease",
    borderRadius: "12px",
    background: "linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%)",
    boxShadow: "0 4px 15px 0 rgba(0,0,0,0.08)",
    "&:hover": {
      transform: "translateY(-5px)",
      boxShadow: "0 10px 25px -5px rgba(0,0,0,0.15)",
      background: "linear-gradient(145deg, #ffffff 0%, #f0f2f5 100%)",
    },
  },
  paymentOption: {
    padding: theme.spacing(3),
    margin: theme.spacing(1),
    cursor: "pointer",
    transition: "all 0.3s ease",
    height: "100%",
    borderRadius: "12px",
    background: "linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%)",
    boxShadow: "0 4px 15px 0 rgba(0,0,0,0.08)",
    "&:hover": {
      transform: "scale(1.03)",
      boxShadow: "0 10px 25px -5px rgba(0,0,0,0.15)",
      background: "linear-gradient(145deg, #ffffff 0%, #f0f2f5 100%)",
    },
  },

  progressBar: {
    height: 12,
    borderRadius: 6,
    margin: theme.spacing(2, 0),
    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
    [theme.breakpoints.down("sm")]: {
      height: 8,
    },
  },
  sectionTitle: {
    fontWeight: 700,
    color: theme.palette.primary.dark,
    marginBottom: theme.spacing(3),
    position: "relative",
    "&:after": {
      content: '""',
      position: "absolute",
      bottom: -8,
      left: 0,
      width: "60px",
      height: "4px",
      background: theme.palette.primary.main,
      borderRadius: "2px",
    },
  },
  avatar: {
    width: theme.spacing(7),
    height: theme.spacing(7),
    marginRight: theme.spacing(2),
    background: "linear-gradient(135deg, #3f51b5 0%, #2196f3 100%)",
  },
  welcomeCard: {
    background: "linear-gradient(135deg, #3f51b5 0%, #2196f3 100%)",
    color: "white",
    borderRadius: "12px",
    padding: theme.spacing(3),
    marginBottom: theme.spacing(3),
    boxShadow: "0 10px 30px -5px rgba(63,81,181,0.3)",
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(2),
    },
  },
  iconWrapper: {
    backgroundColor: "rgba(255,255,255,0.2)",
    borderRadius: "50%",
    padding: theme.spacing(1.5),
    display: "inline-flex",
    marginRight: theme.spacing(2),
  },
  stepperRoot: {
    background: "transparent",
    padding: theme.spacing(3, 0),
  },
  stepLabel: {
    fontWeight: 600,
    color: theme.palette.text.primary,
  },
  stepIconCompleted: {
    color: `${theme.palette.success.main} !important`,
  },
  stepIconActive: {
    color: `${theme.palette.secondary.main} !important`,
  },

  "@keyframes pulse": {
    "0%": {
      opacity: 0.6,
    },
    "50%": {
      opacity: 1,
    },
    "100%": {
      opacity: 0.6,
    },
  },

  skeletonPulse: {
    animation: "$pulse 1.5s ease-in-out infinite",
  },

  typography: {
    h5: {
      fontSize: "1.2rem",
      [theme.breakpoints.down("sm")]: {
        fontSize: "1rem",
      },
    },
    body1: {
      [theme.breakpoints.down("sm")]: {
        fontSize: "0.875rem",
      },
    },
  },
});

// ... (keep all your existing imports and context setup)

class Dashboard extends React.Component {
  constructor() {
    super();
    this.state = {
      loader: true,
      pwdDialog: false,
      status: false,
      activeStep: 0,
      IsOlevelSaved: false,
      IsBiodataSaved: false,
      IsNDSaved: false,
      RegComplete: false,
      JambRegNo: null,
      Admitted: false,
      warning: false,
      acceptance: 0,
      IsPasswdChgd: false,
      AdmissionStatus: false,
      IsDocUpload: false,
      admissionLetterDrawer: false,
      paymentDialog: false,
      message: "",
      statusResponse: null,
      accreditationFee: "",
      changeofDepartmentFee: "",
      remitaResponse: null,
      paymentType: null,
      transactionStatus: null,
      activeDraw: 0,
      isResultSaved: false,
      FeeLoader: false,
      downloadDoc: [
        {
          fileExt: "",
          formId: 1,
          formUrl: "",
          levelIds: null,
          formName: "Provisional Admission Letter",
          departmentIds: null,
          formDescription: "View Letter showing Provisional Admission Details",
        },
        // {
        //   fileExt: "",
        //   formId: 2,
        //   formUrl: "",
        //   levelIds: null,
        //   formName: "Receipt Payment for  Acceptance",
        //   departmentIds: null,
        //   formDescription: "View Payment for Acceptance Receipt Details",
        // },
        // {
        //   fileExt: "",
        //   formId: 3,
        //   formUrl: "",
        //   levelIds: null,
        //   formName: "School Fees Chart",
        //   departmentIds: null,
        //   formDescription: "View School Fees Chart Details",
        // },
        // {
        //   fileExt: "",
        //   formId: 4,
        //   formUrl: "",
        //   levelIds: null,
        //   formName: "Acceptance Form",
        //   departmentIds: null,
        //   formDescription: "View Acceptance Form Details",
        // },
        // {
        //   fileExt: "",
        //   formId: 5,
        //   formUrl: "",
        //   levelIds: 3,
        //   formName: "SIWES",
        //   departmentIds: null,
        //   formDescription: "View SIWES Form Details",
        // },
      ],
      applicantData: {},
      applicationSlip: false,
      olevel: [],
      CourseofStudy: "",
      portalCharges: "",
      acceptPayment: [],
      checkifApplicantsExist: false,
      isVerificationPaid: false,
      verificationPayment: null, // holds details and dialog open/close
      verificationPaymentDetails: null,
      showVerificationPayment: false,
      RegStatus: null,
      showWelcomeModal: true,
      paymentOptionDialog: false,
      isMobile: false,
      paymentStatusLoader: false,
      screeningExerciseDiag: false,
      provisionalAdmissionLetterDiag: false,
      ApproveCourse: null,
      DeptID: null,
      EntranceExam: false,
    };
  }

  toggleDrawer = (side, open) => () => {
    this.setState({
      [side]: open,
    });
  };

  getSteps = () => {
    return [
      "Biodata",
      "Utme",
      "Results",
      // "Documents",
      "Registration Completed",
      "Admitted",
    ];
  };

  async componentDidMount() {
    try {
      this.handleResize();
      window.addEventListener("resize", this.handleResize);
      this.loadContent();
      this.status();
      // this.checkVerificationPaymentStatus();
      this.getApplicantAcceptanceFee();
    } catch (error) {
      NotificationManager.error("An error occurred.");
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  formatCurrency = (amount) => {
    if (!amount) return "0";
    return parseInt(amount).toLocaleString("en-US");
  };

  handleResize = () => {
    const isMobile = window.innerWidth < 960; // Match your breakpoint
    if (isMobile !== this.state.isMobile) {
      this.setState({ isMobile });
    }
  };

  onCancelWarning = () => {
    this.setState({
      warning: false,
    });
  };

  //function to close the modal that display stepper info
  closeWelcomeModal = () => {
    this.setState({ showWelcomeModal: false });
  };
  closePayment = (val) => {
    this.setState({
      paymentDialog: val,
    });
    // this.setState({
    //   paymentStatus: val,
    // });
  };

  getResultsCompletionStatus(EntryModeId, IsOlevelSaved, JambRegNo, IsNDSaved) {
    switch (EntryModeId) {
      case 1: // UTME + O'Level
        return IsOlevelSaved && JambRegNo !== null && JambRegNo !== "";
      case 2: // O'Level only
        return IsOlevelSaved;
      case 3: // O'Level + ND
        return IsOlevelSaved && IsNDSaved;
      default:
        return false;
    }
  }

  // closePaymentStatus = (val) => {
  //   this.setState(
  //     {
  //       paymentStatus: val,
  //     },
  //     this.props.history.push("/applicant/dashboard")
  //   );
  // };
  closePaymentStatus = (val) => {
    this.setState(
      {
        paymentStatus: val,
      },
      () => {
        // Reload the page and navigate to the desired route
        window.location.href = "/applicant/dashboard";
      }
    );
  };


  status = async () => {
    this.setState({ paymentStatusLoader: true });

    try {
      const { token } = this.props.authUser;
      const urlParams = new URLSearchParams(window.location.search);
      const transactionReference = urlParams.get("paymentReference");
      const nombaReference = urlParams.get("orderId");

      // If neither reference exists, exit early
      // if (!transactionReference && !nombaReference) {
      //   throw new Error("No payment reference found");
      // }
      this.setState({ paymentStatusLoader: true });
      let response;

      if (transactionReference) {
        response = await fetchJSON(
          `api/CheckPayeePaymentMonnify?paymentReference=${transactionReference}`,
          null,
          "GET",
          token
        );

        // Handle Monnify payment response
        if (response.Status === "Ok" && response.Data?.status === "Success") {
          this.setState({
            transactionStatus: "success",
            paymentStatus: true,
            message: "Payment successful! Thank you.",
            statusResponse: response?.Data,
            paymentStatusLoader: false,
          });
        } else if (response.Status === "Ok" && response.status === "Pending") {
          this.setState({
            transactionStatus: "Pending",
            paymentStatus: true,
            message: "Payment Pending or not completed. Please try again.",
            statusResponse: response?.Data,
            paymentStatusLoader: false,
          });
        } else {
          this.setState({
            transactionStatus: "failure",
            message: "Payment failed or not completed. Please try again.",
            statusResponse: response?.Data,
            paymentStatus: true,
          });
        }
      } else if (nombaReference) {
        response = await fetchJSON(
          `api/CheckPayeePaymentNomba?transactionReference=${nombaReference}`, // Fixed endpoint URL
          null,
          "GET",
          token
        );
        if (response.Status === "Ok" && response.Data?.status === "Success") {
          this.setState({
            transactionStatus: "success",
            paymentStatus: true,
            message: "Payment successful! Thank you.",
            statusResponse: response?.Data,
            paymentStatusLoader: false,
          });
        } else if (
          response.Status === "Ok" &&
          response.Data?.status === "Failed"
        ) {
          this.setState({
            transactionStatus: "failure",
            message:
              response.Message ||
              "Payment failed or not completed. Please try again.",
            statusResponse: response?.Data,
            paymentStatus: true,
          });
        }
        // Handle Nomba payment response
      }
    } catch (error) {
      console.error("Payment status check failed:", error);
      this.setState({
        transactionStatus: "failure",
        message: "An error occurred while checking payment status.",
      });
    } finally {
      this.setState({ paymentStatusLoader: false });
    }
  };

  /* #region  Download function for pdf */
  download = (rowData) => {
    try {
      axios({
        url: rowData.formUrl,
        method: "GET",
        responseType: "blob",
      }).then((response) => {
        NotificationManager.success("Download will begin shortly!");
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${rowData.formName}.${rowData.fileExt}`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    } catch (error) {
      NotificationManager.error("An error occurred!");
    }
  };
  /* #endregion */

  handleRequestClose = () => {
    this.setState({ pwdDialog: false });
    this.props.history.push("/applicant/changepassword");
  };

  checkMatricNumber = (matricNo, dataArray) => {
    if (!matricNo) return false;

    // Check if the auth user's matric number is in the data array
    return dataArray.includes(matricNo);
  };
  /* #region run on load of page and get necessary documents for download for applicants */
  // loadContent = async () => {
  //   try {
  //     this.setState({
  //       loader: true,
  //     });
  //     const { token, ApplicantID, EntryModeId } = this.props.authUser;
  //     const response = await fetchJSON(
  //       `api/Applicants/GetApplicantRecordById?ApplicantID=${ApplicantID}`,
  //       null,
  //       "GET",
  //       token
  //     );
  //     const admissionDocs = await fetchJSON(
  //       `api/listofforms?type=${2}`,
  //       null,
  //       "GET",
  //       token
  //     );

  //     if (response.Status === "Ok") {
  //       let docs;
  //       const {
  //         IsOlevelSaved,
  //         IsBiodataSaved,
  //         RegComplete,
  //         IsPasswdChgd,
  //         AdmissionStatus,
  //         IsUploadDocument,
  //         AdmissionLevel,
  //         CourseofStudy,
  //         JambRegNo,
  //         RegStatus,
  //         IsNDSaved,
  //       } = response.Data;
  //       if (admissionDocs.Data) {
  //         docs = [...this.state.downloadDoc, ...admissionDocs.Data];
  //       } else {
  //         docs = [...this.state.downloadDoc];
  //       }

  //       if (AdmissionLevel === 4) {
  //         const AcceptancePayment = await fetchJSON(
  //           `api/ApplicantAcceptancePaymentHistory?payeeId=${ApplicantID}`,
  //           null,
  //           "GET",
  //           token
  //         );
  //         if (AcceptancePayment.Status === "Ok") {
  //           this.setState({ acceptPayment: AcceptancePayment.Data });
  //         }
  //       }

  //       this.setState({
  //         IsOlevelSaved: IsOlevelSaved,
  //         IsBiodataSaved: IsBiodataSaved,
  //         RegComplete: RegComplete,
  //         IsPasswdChgd: IsPasswdChgd,
  //         IsDocUpload: IsUploadDocument,
  //         AdmissionStatus: AdmissionStatus,
  //         Admitted: false,
  //         JambRegNo: JambRegNo,
  //         acceptance: AdmissionLevel,
  //         downloadDoc: docs,
  //         applicantData: response.Data,
  //         CourseofStudy: CourseofStudy,
  //         RegStatus: RegStatus,
  //         IsNDSaved: IsNDSaved,
  //         loader: false,
  //       });
  //       //   this.setState({ loader: false });
  //       const isResultsCompleted = this.getResultsCompletionStatus(
  //         EntryModeId,
  //         IsOlevelSaved,
  //         JambRegNo,
  //         IsNDSaved
  //       );

  //       // Check if results are now complete AND the user is currently on the results page.
  //       // If so, redirect them to the dashboard to see their updated progress.
  //       if (
  //         isResultsCompleted &&
  //         this.props.location.pathname.includes("/applicant/results")
  //       ) {
  //         NotificationManager.success("Results saved successfully!");
  //         this.props.history.push("/applicant/dashboard");
  //       }
  //       if (IsPasswdChgd === null) {
  //         this.setState({ pwdDialog: true });
  //       }
  //     } else {
  //       NotificationManager.error("Unable to complete operation.");
  //       this.setState({
  //         loader: false,
  //       });
  //     }
  //   } catch (error) {
  //     this.setState({ loader: false });
  //     NotificationManager.error("An error occurred.");
  //   } finally {
  //     this.setState({ loader: false });
  //   }
  // };
  loadContent = async () => {
    try {
      this.setState({
        loader: true,
      });
      const { token, ApplicantID, EntryModeId } = this.props.authUser;

      // Execute both API calls in parallel for better performance
      const [response, admissionDocs] = await Promise.all([
        fetchJSON(
          `api/Applicants/GetApplicantRecordById?ApplicantID=${ApplicantID}`,
          null,
          "GET",
          token
        ),
        fetchJSON(
          `api/listofforms?type=${2}`,
          null,
          "GET",
          token
        )
      ]);

      if (response.Status === "Ok") {
        let docs;
        const {
          IsOlevelSaved,
          IsBiodataSaved,
          RegComplete,
          IsPasswdChgd,
          AdmissionStatus,
          IsUploadDocument,
          AdmissionLevel,
          CourseofStudy,
          JambRegNo,
          RegStatus,
          IsNDSaved,
          ApproveCourse,
          WaecVerify,
          DeptID,
        } = response.Data;
        // aplicants who have been upoladed from the admin side for entrance exam will have the entrance exam details in the applicant data and will have provisional admission letter
        const EntranceExam = response.Data2;

        if (admissionDocs.Data) {
          docs = [...this.state.downloadDoc, ...admissionDocs.Data];
        } else {
          docs = [...this.state.downloadDoc];
        }

        let acceptPayment = null;

        // Handle conditional API call
        if (AdmissionLevel === 4) {
          const AcceptancePayment = await fetchJSON(
            `api/ApplicantAcceptancePaymentHistory?payeeId=${ApplicantID}`,
            null,
            "GET",
            token
          );
          if (AcceptancePayment.Status === "Ok") {
            acceptPayment = AcceptancePayment.Data;
          }
        }

        this.props.updateApplicantData(response.Data);
        // Set all state at once after all API calls are complete
        this.setState({
          IsOlevelSaved: IsOlevelSaved,
          IsBiodataSaved: IsBiodataSaved,
          RegComplete: RegComplete,
          IsPasswdChgd: IsPasswdChgd,
          IsDocUpload: IsUploadDocument,
          AdmissionStatus: AdmissionStatus,
          Admitted: false,
          JambRegNo: JambRegNo,
          acceptance: AdmissionLevel,
          downloadDoc: docs,
          applicantData: response.Data,
          CourseofStudy: CourseofStudy,
          RegStatus: RegStatus,
          IsNDSaved: IsNDSaved,
          acceptPayment: acceptPayment,
          loader: false,
          ApproveCourse: ApproveCourse,
          WaecVerify: WaecVerify,
          DeptID: DeptID,
          EntranceExam: EntranceExam,
        });

        if(IsBiodataSaved && AdmissionLevel === 1) {
          this.getApplicantAccreditationFee(response.Data);
          this.getApplicantChangeofDepartmentFee(response.Data);
        }
        
        const isResultsCompleted = this.getResultsCompletionStatus(
          EntryModeId,
          IsOlevelSaved,
          JambRegNo,
          IsNDSaved
        );

        // Check if results are now complete AND the user is currently on the results page.
        // If so, redirect them to the dashboard to see their updated progress.
        if (
          isResultsCompleted &&
          this.props.location.pathname.includes("/applicant/results")
        ) {
          NotificationManager.success("Results saved successfully!");
          this.props.history.push("/applicant/dashboard");
        }

        if (IsPasswdChgd === null || IsPasswdChgd === 0) {
          this.setState({ pwdDialog: true });
        }
      } else {
        NotificationManager.error("Unable to complete operation.");
        this.setState({
          loader: false,
        });
      }
    } catch (error) {
      
      this.setState({ loader: false });
      // NotificationManager.error("An error occurred.");
    }

    console.log(this.state.EntranceExam, "EntryModeId");
  };
  /* #endregion */

  /* #region  Get RRR and ready payment settings */
  initiateNomba = async () => {
  
    try {
      const {
        SessionID,
        SchoolID,
        token,
        DOB,
        FirstName,
        LastName,
        OtherName,
        Email,
        PhoneNumber,
        Gender,
        DepartmentName,
        // DOB,
        ApplicantID,
        DeptID,
        LevelID,
        JambRegNo,
        AdmModeId,
      } = this.props.authUser;

      const { IsBiodataSaved, acceptance } = this.state;
      // 10 acceptance fee, 6 schoolfee, 
      const payType =
        // IsBiodataSaved && acceptance < 1 ? 10 : acceptance == 1 ? 6 :  acceptance == 4 ? 16 : 21;
        IsBiodataSaved && acceptance < 1 ? 10 : acceptance == 1 ? 6 : acceptance === 5 ? 15 : 16;
      this.setState({ loader: true });

      let model = {
        SessionID: SessionID,
        SchoolID: SchoolID,
        FirstName: FirstName,
        OtherName: OtherName,
        LastName: LastName,
        DepartmentName: DepartmentName,
        Email: Email,
        PhoneNumber: PhoneNumber,
        Gender: Gender,
        // DateOfBirth: DOB,
        DeptID: DeptID,
        LevelID: LevelID,
        AdmModeId: AdmModeId,
        PayeeTypeId: 1,
        PaymentCategoryId: payType,
        PayeeId: ApplicantID,
        ApplicantID: ApplicantID,
        JambRegNo: JambRegNo,
        PayeeName: `${FirstName} ${OtherName} ${LastName}`,
        PaymentItemId: [2],
        PayeeEmail: Email,
      };

      const response = await fetchJSON(
        `api/AddPayeePaymentNomba?payType=${payType}`,
        model,
        "POST",
        token
      );

      if (response.Status == "OK") {
        response.Data.token = token;
        response.Data.payerEmail = Email;
        response.Data.payerPhone = PhoneNumber;
        response.Data.payerName = model.PayeeName;
        response.Data.LevelID = LevelID;
        location.href = response?.Data?.checkOutUrl;
        this.setState({
          loader: false,
          remitaResponse: response.Data,
          paymentType: "Nomba",
          // paymentDialog: true,
        });
        NotificationManager.success("Transaction Ref generated successfully");
      } else {
        this.setState({ loader: false });
        NotificationManager.error(response.Message);
        return false;
      }
    } catch (e) {
      NotificationManager.error("An Error Occurred3");
      this.setState({ loader: false });
      e;
    }
  };
  // endpoint for Monnify payment for acceptance fee
  initiateMonnify = async () => {
    try {
      const {
        ApplicantID,
        token,
        Email,
        FirstName,
        LastName,
        OtherName,
        SessionID,
        Gender,
        DeptID,
        SecondChoiceCourseStudy,
        AdmModeId,
        DepartmentName,
        LevelID,
        EntryModeId,
        PhoneNumber,
        ProgramTypeId,
        SchoolID,
      } = this.props.authUser;
      this.setState({ loader: true });
      // const { TotalAmountToPay } = this.state.verificationPayment;

      const { IsBiodataSaved, acceptance } = this.state;

      const payType =
        IsBiodataSaved && acceptance < 1 ? 10 : acceptance == 1 ? 6 : acceptance === 5 ? 15 : 16

      let model = {
        PayeeId: ApplicantID,
        FirstName: FirstName,
        LastName: LastName,
        OtherName: OtherName,
        Email: Email,
        Phone: PhoneNumber,
        SchoolID: SchoolID,
        Gender: Gender,
        DeptID: DeptID,
        DeptID2: SecondChoiceCourseStudy,
        AdmModeId: AdmModeId,
        DepartmentName: DepartmentName,
        ProgramTypeId: ProgramTypeId,
        SessionID: SessionID,
        PayeeTypeId: 1,
        PaymentCategoryId: payType,
        // PaymentItemId: [1],
        LevelID: LevelID,
        EntryTypeId: EntryModeId,
      };

      const response = await fetchJSON(
        `api/AddPayeePaymentMonnify?payType=${payType}`,
        model,
        "POST",
        token
      );

      if (response.Status == "OK") {
        response.Data.token = token;
        response.Data.payerEmail = Email;
        response.Data.payerPhone = PhoneNumber;
        response.Data.payerName = model.PayeeName;
        response.Data.LevelID = LevelID;
        location.href = response?.Data?.checkOutUrl;
        this.setState({
          loader: false,
          remitaResponse: response.Data,
          paymentType: "Monnify",
          // paymentDialog: true,
        });
        NotificationManager.success("Transaction Ref generated successfully");
      } else {
        this.setState({ loader: false });
        NotificationManager.error(response.Message);
        return false;
      }
    } catch (e) {
      NotificationManager.error("An Error Occurred3");
      this.setState({ loader: false });
      e;
    }
  };
  /* #endregion */

  /* #region  Get RRR and ready payment settings */
  initiateRemita = async () => {
    try {
      const {
        SessionID,
        SchoolID,
        token,
        DOB,
        FirstName,
        LastName,
        OtherName,
        Email,
        PhoneNumber,
        Gender,
        DepartmentName,
        // DOB,
        ApplicantID,
        DeptID,
        LevelID,
        JambRegNo,
        AdmModeId,
      } = this.props.authUser;
      // const { FirstName,
      //   LastName,
      //   OtherName,
      //   Email,
      //   PhoneNumber,
      //   Gender,
      //   // DOB,
      //   ApplicantID,
      //   DeptID,
      //   LevelId,JambRegNo, AdmModeId } = applicantData;
      this.setState({ loader: true });
      // PaymentCategoryId = 10 from backend
      let model = {
        SessionID: SessionID,
        SchoolID: SchoolID,
        FirstName: FirstName,
        OtherName: OtherName,
        LastName: LastName,
        DepartmentName: DepartmentName,
        Email: Email,
        PhoneNumber: PhoneNumber,
        Gender: Gender,
        // DateOfBirth: DOB,
        DeptID: DeptID,
        LevelID: LevelID,
        AdmModeId: AdmModeId,
        PayeeTypeId: 1,
        PaymentCategoryId: 10,
        PayeeId: ApplicantID,
        ApplicantID: ApplicantID,
        JambRegNo: JambRegNo,
        PayeeName: `${FirstName} ${OtherName} ${LastName}`,
        PaymentItemId: [2],
        PayeeEmail: Email,
      };

      const response = await fetchJSON(
        `api/AddPayeePayment?payType=${10}`,
        model,
        "POST",
        token
      );


      if (response.Status == "OK") {
        response.Data.token = token;
        response.Data.payerEmail = Email;
        response.Data.payerPhone = PhoneNumber;
        response.Data.payerName = model.PayeeName;
        response.Data.LevelID = LevelID;
        this.setState({
          loader: false,
          remitaResponse: response.Data,
          paymentType: "Remita",
          paymentDialog: true,
        });
        NotificationManager.success("Transaction Ref generated successfully");
      } else {
        this.setState({ loader: false });
        NotificationManager.error(response.Message);
        return false;
      }
    } catch (e) {
      NotificationManager.error("An Error Occurred3");
      this.setState({ loader: false });
      e;
    }
  };
  /* #endregion */

  //confirm reg submission=== === ===
  handleReg = async () => {
    const { token, ApplicantID } = this.props.authUser;
    const regcomplete = await fetchJSON(
      `/api/Applicants/SubmitReg?applicantId=${ApplicantID}`,
      null,
      "GET",
      token
    );

    if (regcomplete.Status === "OK") {
      this.props.regStatus(regcomplete.Data);
      this.setState((prevState) => ({ activeStep: prevState.activeStep }));
      this.setState({
        RegComplete: true,
        warning: false,
      });
      // this.setState({ applicationSlip: true });
    } else {
      NotificationManager.warning(regcomplete.Message);
    }
  };



  payVerificationMonnify = async () => {
    const {
      ApplicantID,
      token,
      Email,
      FirstName,
      LastName,
      OtherName,
      SessionID,
      Gender,
      DeptID,
      AdmModeId,
      DepartmentName,
      LevelID,
      EntryModeId,
      PhoneNumber,
      ProgramTypeId,
    } = this.props.authUser;
    this.setState({ loader: true });
    const { TotalAmountToPay } = this.state.verificationPayment;
    let model = {
      PayeeId: ApplicantID,
      FirstName: FirstName,
      LastName: LastName,
      OtherName: OtherName,
      Email: Email,
      Phone: PhoneNumber,

      Gender: Gender,
      DeptID: DeptID,
      AdmModeId: AdmModeId,
      DepartmentName: DepartmentName,
      ProgramTypeId: ProgramTypeId,
      SessionID: SessionID,
      // PaymentItemId: [1],
      LevelID: LevelID,
      EntryTypeId: EntryModeId,
    };
    const response = await fetchJSON(
      `api/AddPayeePaymentMonnify?payType=${9}`,
      model,
      "POST",
      token
    );
    if (response.Status === "OK") {
      this.setState({
        loader: false,
        verificationPayment: { open: false },
      });
      window.location.href = response.Data.checkOutUrl;
    } else {
      NotificationManager.error(response.Message);
      this.setState({
        loader: false,
      });
    }
  };

  payVerificationNomba = async () => {
    const {
      ApplicantID,
      token,
      Email,
      FirstName,
      LastName,
      OtherName,
      SessionID,
      Gender,
      DeptID,
      AdmModeId,
      DepartmentName,
      LevelID,
      EntryModeId,
      PhoneNumber,
      ProgramTypeId,
    } = this.props.authUser;
    this.setState({
      loader: true,
    });
    const { TotalAmountToPay } = this.state.verificationPayment;
    let model = {
      PayeeId: ApplicantID,
      FirstName: FirstName,
      LastName: LastName,
      OtherName: OtherName,
      Email: Email,
      Phone: PhoneNumber,

      Gender: Gender,
      DeptID: DeptID,
      AdmModeId: AdmModeId,
      DepartmentName: DepartmentName,
      ProgramTypeId: ProgramTypeId,
      SessionID: SessionID,
      // PaymentItemId: [1],
      LevelID: LevelID,
      EntryTypeId: EntryModeId,
    };
    const response = await fetchJSON(
      `api/AddPayeePaymentNomba?payType=${9}`,
      model,
      "POST",
      token
    );
    if (response.Status === "OK") {
      this.setState({
        loader: false,
      });
      window.location.href = response.Data.checkOutUrl;
    } else {
      NotificationManager.error(response.Message);
      this.setState({
        loader: false,
      });
    }
  };
  checkVerificationPaymentStatus = async () => {
    try {
      const { ApplicantID, token } = this.props.authUser;
      const response = await fetchJSON(
        `api/GetApplicantVerificationFeesPayments?applicantId=${ApplicantID}`,
        // `api/VerifyTransaction?paymentReference=${transactionReference}`,
        null,
        "GET",
        token
      );

      if (response.Status == true) {
        this.setState({ portalCharges: response });
        this.setState({ isVerificationPaid: true });
      }
    } catch (e) {
      // Optionally handle error
    }
  };

  getApplicantAcceptanceFee = async () => {
    try {
      const { ApplicantID, token } = this.props.authUser;
      const response = await fetchJSON(
        `api/GetApplicationFeesPayment?applicantId=${ApplicantID}`,
        // `api/VerifyTransaction?paymentReference=${transactionReference}`,
        null,
        "GET",
        token
      );
      if (response.Status == true) {
        this.setState({ portalCharges: response });
      }
    } catch (e) {
      // Optionally handle error
    }
  };
  getApplicantAccreditationFee = async (data) => {
    try {
      const applicantData = data || this.props.authUser;
      const {
        ApplicantID,
        DeptID,
        SessionID,
        LevelID,
      } = applicantData;
      const { token } = this.props.authUser;

      const response = await fetchJSON(
        `api/GetAcrreditationSchoolFeesAmount?PayeeId=${ApplicantID}&SessionId=${SessionID}&DepartmentId=${DeptID}&LevelId=${LevelID}`,
        null,
        "GET",
        token
      );
      if (response.Status === "Success") {
        this.setState({ FeeLoader: false });
        this.setState({ accreditationFee: response.Data });
      } else {
        this.setState({ FeeLoader: false });
        NotificationManager.error(response.Message);
        return false;
      }
    } catch (e) {
      NotificationManager.error("An Error Occurred3");
      this.setState({ FeeLoader: false });
    }
  };
  getApplicantChangeofDepartmentFee = async (data) => {
    try {
      const applicantData = data || this.props.authUser;
      const {
        // ApplicantID,
        DeptID,
        SessionID,
        LevelID,
      } = applicantData;
      const { token, ApplicantID } = this.props.authUser;

      // const {DeptID} = this.applicantData.state
      const model = {
        departmentId: DeptID,
        levelId: LevelID,
        // payeeId: ApplicantID,
        sessionId: SessionID,
      };
      const response = await fetchJSON(
        `api/GetChangeOfCourseFees`,
        model,
        "POST",
        token
      );
      if (response) {
        this.setState({ FeeLoader: false });
        this.setState({ changeofDepartmentFee: response });
      } else {
        this.setState({ FeeLoader: false });
        // NotificationManager.error(response.Message);
        return false;
      }
    } catch (e) {
      NotificationManager.error("An Error Occurred");
      this.setState({ FeeLoader: false });
    }
  };


  getCurrentStepDetails() {
    const {
      IsBiodataSaved,
      IsOlevelSaved,
      RegComplete,
      AdmissionStatus,
      acceptance,
      JambRegNo,
      RegStatus,
      IsDocUpload,
      IsNDSaved,
      ApproveCourse,
      WaecVerify,
      EntranceExam,
    } = this.state;
    const { EntryModeId } = this.props.authUser;
    const isResultsCompleted = this.getResultsCompletionStatus(
      EntryModeId,
      IsOlevelSaved,
      JambRegNo,
      IsNDSaved
    );
    
    const isDST = this.props.authUser.DeptID === DSTPartTimeDepartmentId;

    const steps = [
      {
        id: 1,
        title: "Biodata Completion",
        description: "Fill in your personal information and contact details",
        completed: IsBiodataSaved,
        active: !IsBiodataSaved,
        actions: !IsBiodataSaved
          ? [
            {
              label: "Update Biodata",
              link: "/applicant/biodata",
            },
          ]
          : [],
      },
      {
        id: 2,
        title: "Acceptance Fee Payment",
        description: "Pay acceptance fee to secure your admission",
        completed: acceptance >= 1,
        active: IsBiodataSaved && acceptance < 1,
        actions: (isDST && acceptance >= 1) ? [] : (IsBiodataSaved && ( EntranceExam))
          ? [
            {
              label: "Pay Acceptance Fee",
              action: () => this.setState({ paymentOptionDialog: true }),
            },
          ]
          : [],
      },
      {
        id: 3,
        title: "School Fee Payment",
        description: "Pay school fee",
        completed: acceptance >= 2,
        active: IsBiodataSaved && acceptance === 1,
        actions:
          acceptance === 1
            ? [
              {
                label: "Pay School Fee",
                action: () => this.setState({ paymentOptionDialog: true }),
              },
            ]
            : [],
      },
      {
        id: 4,
        title: "Results",
        description: "Upload your results ",
        completed: acceptance >= 3,
        active: IsBiodataSaved && acceptance === 2,
        actions:
          acceptance === 2
            ? [
              {
                label: "Upload Results",
                link: "/applicant/results",
              },
            ]
            : [],
      },
      {
        id: 5,
        title: "Documents Upload",
        description: "Upload your supporting documents",
        completed: acceptance >= 4 && isResultsCompleted,
        active: IsBiodataSaved && acceptance === 3,
        actions:
          acceptance === 3
            ? [
              {
                label: "Upload Documents",
                link: "/applicant/documents",
              },
            ]
            : [],
      },
      {
        id: 6,
        title: "Screening ",
        description: "Screening Exercise In Progress Kindly Check Back Later",
        completed: acceptance >= 5 && IsBiodataSaved,
        active: IsBiodataSaved && acceptance === 4,
        actions: [],
      },

      // STEP 7 — CHANGE OF DEPARTMENT FEE (ONLY IF ApproveCourse != null)
      ...(ApproveCourse != null 
        ? [
          {
            id: 7,
            title: "Change of Department Fee",
            description: "Pay Change of Department Fee",
            completed: acceptance >= 6 && IsBiodataSaved,
            active: IsBiodataSaved && acceptance === 5,
            actions:
              acceptance === 5
                ? [
                  {
                    label: "Pay Change of Department Fee",
                    action: () =>
                      this.setState({ paymentOptionDialog: true }),
                  },
                ]
                : [],
          },
        ]
        : []),
      {
        id: ApproveCourse != null ? 8 : 7,
        title: "Admission",
        description: RegComplete === false ||   RegComplete === null ? "Final Step !!! click on the button to complete your Admission " : "Congratulations on your admission! Your admission letter and login details will be sent to your email shortly. Please monitor your  inbox regularly.",
        completed: RegComplete === true && IsBiodataSaved,
        active: RegComplete === false ||  RegComplete === null && acceptance >= (ApproveCourse != null ? 6 : 5) && IsBiodataSaved,
        actions:  RegComplete === false || RegComplete === null ? [
          {
            label: "Click here to complete your admission",
            action: () =>
              this.setState({
                warning: true,
                // activeDraw: this.state.downloadDoc[2]?.formId,
              }),
          },
        ] :[],
      },


    ];
    
    let filteredSteps = steps;

if (isDST) {
  filteredSteps = steps.filter(step => step.id <= 2);
}

    return filteredSteps;
  }

  renderStepProgress() {
    const { classes } = this.props;
    const { acceptance, ApproveCourse, IsBiodataSaved } = this.state;
    const { EntryModeId } = this.props.authUser;
    const steps = this.getCurrentStepDetails();
    // const activeStep = steps.findIndex(
    //   (step) =>
    //     step.active ||
    //     (!step.completed && !step.active && !steps.some((s) => s.active))
    // );
    const activeStep = steps.findIndex((step) => step.active);
    const { isMobile } = this.state;
    const displayStep = activeStep === -1 ? steps.length : activeStep;
    // Mirror the Stepper's own positional logic (steps before the active one
    // are shown checkmarked) so the "X of Y completed" text always agrees
    // with what the Stepper renders, instead of re-deriving it from each
    // step's own `completed` flag (some, like Documents Upload, use compound
    // conditions that can lag behind the applicant's real acceptance level).
    const completedStepsCount = displayStep;

    return (
      <Box className={classes.root}>
        {/* Welcome Card - stays full width on all screens */}
        <Card className={classes.welcomeCard}>
          <Box display="flex" alignItems="center">
            <div className={classes.iconWrapper}>
              <GetAppIcon style={{ color: "white", fontSize: 30 }} />
            </div>
            <Box>
              <Typography
                variant="h5"
                gutterBottom
                style={{ color: "white", fontWeight: 600 }}
              >
                Welcome, {this.props.authUser.FirstName}!
              </Typography>
              <Typography
                variant="body1"
                style={{ color: "rgba(255,255,255,0.9)" }}
              >
                Your application progress is shown below. Complete all steps to
                finish your admission process.
              </Typography>
            </Box>
          </Box>
        </Card>
        <Box mt={2} mb={2} display="flex" justifyContent="flex-end" sx={{ gap: 6 }}>
          {acceptance >= 1 && (
            <Button
              size="small"
              color="secondary"
              variant="outlined"
              onClick={() => this.setState({ screeningExerciseDiag: true })}
              style={{ borderRadius: "8px", fontWeight: 600 }}
            >
              Acceptance Letter
            </Button>
          )}
          
          {(IsBiodataSaved && this.props.authUser.DeptID == DSTPartTimeDepartmentId) && (
            <Button
              size="small"
              color="secondary"
              variant="outlined"
              onClick={() => this.setState({ provisionalAdmissionLetterDiag: true })}
              style={{ borderRadius: "8px", fontWeight: 600 }}
            >
              Provisional Admission Letter
            </Button>
          )}
          
          {(IsBiodataSaved && this.state.EntranceExam && this.props.authUser.DeptID != DSTPartTimeDepartmentId) && (
            <Button
              size="small"
              color="secondary"
              variant="outlined"
              onClick={() => this.setState({
                admissionLetterDrawer: true,
                activeDraw: this.state.downloadDoc[0]?.formId,
              })}
              style={{ borderRadius: "8px", fontWeight: 600 }}
            >
              Provisional Admission Letter
            </Button>
          )}
        </Box>
        <Box>
          {acceptance >= 5 && ApproveCourse != null && (
            <Typography
              variant="h6"
              color="secondary">

              {acceptance === 5 && ApproveCourse != null ? (
                `Note: Due to not meeting the cut-off mark for your initial choice, you have been approved for a change to ${ApproveCourse} Department. Please proceed to pay the Change of Department Fee to complete your admission process.`
              ) : (
                `Note: Due to not meeting the cut-off mark for your initial choice, you have been approved for a change to ${ApproveCourse} Department.`
              )}
            </Typography>
          )}
        </Box>

        {/* Responsive container for stepper and content */}
        <Box className={classes.responsiveContainer}>
          {/* Stepper column - becomes narrow on mobile */}
          <Box className={classes.stepperColumn}>
            {isMobile ? (
              <Stepper
                activeStep={displayStep}
                orientation="vertical"
                className={classes.mobileStepper}
              >
                {steps.slice(0, 8).map((step) => (
                  <Step key={step.id}>
                    <StepLabel
                      className={classes.mobileStepLabel}
                      StepIconProps={{
                        classes: {
                          completed: classes.stepIconCompleted,
                          active: classes.stepIconActive,
                        },
                      }}
                    >
                      <Typography
                        variant="subtitle2"
                        className={classes.stepLabel}
                      >
                        {step.title}
                      </Typography>
                    </StepLabel>
                  </Step>
                ))}
              </Stepper>
            ) : null}
          </Box>

          {/* Content column - becomes wider on mobile */}
          <Box className={classes.contentColumn}>
            <Typography
              variant="h5"
              className={classes.sectionTitle}
              gutterBottom
            >
              Application Progress
            </Typography>

            <Box className={classes.progressContainer}>
              <LinearProgress
                variant="determinate"
                value={
                  (completedStepsCount / steps.length) * 100
                }
                className={classes.progressBar}
              />
              <Box display="flex" justifyContent="space-between" mt={1}>
                <Typography variant="caption" color="textSecondary">
                  {completedStepsCount} of {steps.length}{" "}
                  steps completed
                </Typography>
                <Typography variant="caption" color="textSecondary">
                  {Math.round(
                    (completedStepsCount / steps.length) *
                    100
                  )}
                  %
                </Typography>
              </Box>
            </Box>

            {/* Horizontal stepper - shown only on desktop */}
            {!isMobile && (
              <Stepper
                activeStep={displayStep}
                alternativeLabel
                className={classes.stepperRoot}
              >
                {steps.slice(0, 8).map((step) => (
                  <Step key={step.id}>
                    <StepLabel
                      StepIconProps={{
                        classes: {
                          completed: classes.stepIconCompleted,
                          active: classes.stepIconActive,
                        },
                      }}
                    >
                      <Typography
                        variant="subtitle2"
                        className={classes.stepLabel}
                      >
                        {step.title}
                      </Typography>
                    </StepLabel>
                  </Step>
                ))}
              </Stepper>
            )}
          </Box>
        </Box>
      </Box>
    );
  }

  renderStepProgressSkeleton = () => {
    const { classes } = this.props;
    const { isMobile } = this.state;
    const { EntryModeId } = this.props.authUser;

    return (
      <Box className={classes.root}>
        {/* Welcome Card Skeleton - stays full width on all screens */}
        <Card className={classes.welcomeCard}>
          <Box display="flex" alignItems="center">
            <Skeleton
              className={classes.skeletonPulse}
              variant="circle"
              width={56}
              height={56}
              style={{ marginRight: 16 }}
            />
            <Box flex={1}>
              <Skeleton
                className={classes.skeletonPulse}
                variant="text"
                width="60%"
                height={32}
                style={{ marginBottom: 8 }}
              />
              <Skeleton
                className={classes.skeletonPulse}
                variant="text"
                width="80%"
                height={24}
              />
            </Box>
          </Box>
        </Card>

        {/* Responsive container for skeleton stepper and content */}
        <Box className={classes.responsiveContainer}>
          {/* Stepper column skeleton - becomes narrow on mobile */}
          {isMobile && (
            <Box className={classes.stepperColumn}>
              <Stepper
                activeStep={0}
                orientation="vertical"
                className={classes.mobileStepper}
              >
                {(EntryModeId == 1 ? [1, 2, 3, 4, 5, 6, 7] : [1, 2, 3, 4, 5, 6, 7, 8]).map((step) => (
                  <Step key={step}>
                    <StepLabel className={classes.mobileStepLabel}>
                      <Skeleton
                        className={classes.skeletonPulse}
                        variant="text"
                        width={120}
                        height={24}
                      />
                    </StepLabel>
                  </Step>
                ))}
              </Stepper>
            </Box>
          )}

          {/* Content column skeleton - becomes wider on mobile */}
          <Box className={classes.contentColumn}>
            <Skeleton
              className={classes.skeletonPulse}
              variant="text"
              width="40%"
              height={32}
              style={{ marginBottom: 16 }}
            />

            <Box className={classes.progressContainer}>
              <Skeleton
                variant="rect"
                height={12}
                className={classes.progressBar}
              />
              <Box display="flex" justifyContent="space-between" mt={1}>
                <Skeleton
                  className={classes.skeletonPulse}
                  variant="text"
                  width="40%"
                />
                <Skeleton
                  className={classes.skeletonPulse}
                  variant="text"
                  width="20%"
                />
              </Box>
            </Box>

            {/* Horizontal stepper skeleton - shown only on desktop */}
            {!isMobile && (
              <Stepper
                activeStep={0}
                alternativeLabel
                className={classes.stepperRoot}
              >
                
                {(EntryModeId == 1 ? [1, 2, 3, 4, 5, 6, 7] : [1, 2, 3, 4, 5, 6, 7, 8]).map((step) => 
                  (
                  <Step key={step}>
                    <StepLabel>
                      <Skeleton
                        className={classes.skeletonPulse}
                        variant="text"
                        width={80}
                        height={24}
                      />
                    </StepLabel>
                  </Step>
  ))}
              </Stepper>
            )}
          </Box>
        </Box>
      </Box>
    );
  };
 renderCurrentStepCard() {
    const { classes } = this.props;
    const { acceptance, IsBiodataSaved, RegComplete, ApproveCourse } = this.state;
    const { EntryModeId } = this.props.authUser;
    const currentStep =
    this.getCurrentStepDetails().find((step) => step.active) ||
    this.getCurrentStepDetails().find((step) => !step.completed) ||
    this.getCurrentStepDetails().slice(-1)[0];
    
    
    return (
      <Card
        className={
          currentStep.completed
            ? `${classes.stepCard} ${classes.completedStep}`
            : `${classes.stepCard} ${currentStep.active ? classes.activeStep : ""
            }`
        }
      >
        <CardContent>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={2}
          >
            <Typography variant="h6" component="h2" style={{ fontWeight: 600 }}>
              {currentStep.title}
            </Typography>
            <Chip
              label={
                currentStep.completed
                  ? "Completed"
                  : currentStep.active
                    ? "In Progress"
                    : "Pending"
              }
              color={
                currentStep.completed
                  ? "primary"
                  : currentStep.active
                    ? "secondary"
                    : "default"
              }
              className={classes.statusChip}
              variant="outlined"
            />
          </Box>

          <Typography
            color="textSecondary"
            gutterBottom
            style={{ marginBottom: 16 }}
          >
            {currentStep.description}
          </Typography>

          {currentStep.actions.length > 0 && (
            <>
              <Divider
                style={{
                  margin: "16px 0",
                  backgroundColor: "rgba(0,0,0,0.08)",
                }}
              />
              <Typography
                variant="subtitle2"
                gutterBottom
                style={{ fontWeight: 600 }}
              >
                {currentStep.id === this.getCurrentStepDetails()[0].id
                  ? "First "
                  : "Next "}
                Action Required:
              </Typography>
              <Box mt={2} display="flex" flexWrap="wrap">
                {currentStep.actions.map((action, index) =>
                  action.link ? (
                    <Button
                      key={index}
                      variant="contained"
                      color="primary"
                      component={Link}
                      to={action.link}
                      className={classes.actionButton}
                      style={{
                        background: currentStep.active
                          ? "linear-gradient(135deg, #3f51b5 0%, #2196f3 100%)"
                          : "linear-gradient(135deg, #4caf50 0%, #8bc34a 100%)",
                        color: "white",
                      }}
                    >
                      {action.label}
                    </Button>
                  ) : (
                    <Button
                      key={index}
                      variant="contained"
                      color="primary"
                      onClick={action.action}
                      className={classes.actionButton}
                      style={{
                        background: currentStep.active
                          ? "linear-gradient(135deg, #3f51b5 0%, #2196f3 100%)"
                          : "linear-gradient(135deg, #4caf50 0%, #8bc34a 100%)",
                        color: "white",
                      }}
                    >
                      {action.label}
                    </Button>
                  )
                )}
              </Box>
            </>
          )}
        </CardContent>
      </Card>
    );
}
  
  renderCurrentStepCardSkeleton = () => {
    const { classes } = this.props;

    return (
      <Card className={classes.stepCard}>
        <CardContent>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={2}
          >
            <Skeleton
              className={classes.skeletonPulse}
              variant="text"
              width="60%"
              height={32}
            />
            <Skeleton
              className={classes.skeletonPulse}
              variant="rect"
              width={100}
              height={32}
              style={{ borderRadius: 16 }}
            />
          </Box>

          <Skeleton
            className={classes.skeletonPulse}
            variant="text"
            width="90%"
            height={24}
          />
          <Skeleton
            className={classes.skeletonPulse}
            variant="text"
            width="80%"
            height={24}
          />
          <Skeleton
            className={classes.skeletonPulse}
            variant="text"
            width="70%"
            height={24}
          />

          <Box mt={3}>
            <Skeleton
              className={classes.skeletonPulse}
              variant="rect"
              width={150}
              height={40}
              style={{ borderRadius: 8 }}
            />
          </Box>
        </CardContent>
      </Card>
    );
  };
  renderDocumentsSection() {
    // const classes = useStyles;
    const { classes } = this.props;
    const { downloadDoc } = this.state;

    return (
      <Box mt={4}>
        <Typography variant="h5" className={classes.sectionTitle} gutterBottom>
          My Documents
        </Typography>

        <Grid container spacing={3}>
          {downloadDoc.map((doc, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card className={classes.documentCard}>
                <CardContent>
                  <Box display="flex" alignItems="center" mb={2}>
                    <Avatar className={classes.avatar}>
                      <GetAppIcon style={{ color: "white" }} />
                    </Avatar>
                    <Box>
                      <Typography
                        variant="subtitle1"
                        component="h3"
                        style={{ fontWeight: 600 }}
                      >
                        {doc.formName}
                      </Typography>
                      <Typography variant="body2" color="textSecondary">
                        {doc.formDescription}
                      </Typography>
                    </Box>
                  </Box>
                  <Button
                    size="small"
                    color="primary"
                    variant="outlined"
                    fullWidth
                    onClick={() =>
                      doc.formUrl === ""
                        ? this.setState({
                          admissionLetterDrawer: true,
                          activeDraw: doc.formId,
                        })
                        : this.download(doc)
                    }
                    style={{ borderRadius: "8px", fontWeight: 600 }}
                  >
                    View/Download
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    );
  }

  renderDocumentsSectionSkeleton = () => {
    const { classes } = this.props;

    return (
      <Box mt={4}>
        <Skeleton
          className={classes.skeletonPulse}
          variant="text"
          width="30%"
          height={40}
          style={{ marginBottom: 24 }}
        />

        <Grid container spacing={3}>
          {[1, 2, 3].map((item) => (
            <Grid item xs={12} sm={6} md={4} key={item}>
              <Card className={classes.documentCard}>
                <CardContent>
                  <Box display="flex" alignItems="center" mb={2}>
                    <Skeleton
                      className={classes.skeletonPulse}
                      variant="circle"
                      width={56}
                      height={56}
                      style={{ marginRight: 16 }}
                    />
                    <Box flex={1}>
                      <Skeleton
                        className={classes.skeletonPulse}
                        variant="text"
                        width="80%"
                        height={24}
                      />
                      <Skeleton
                        className={classes.skeletonPulse}
                        variant="text"
                        width="90%"
                        height={20}
                      />
                    </Box>
                  </Box>
                  <Skeleton
                    className={classes.skeletonPulse}
                    variant="rect"
                    height={36}
                    style={{ borderRadius: 8 }}
                  />
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    );
  };
  // modal that displays the payment options
  renderPaymentOptions() {
    const { classes } = this.props;
    const {
      IsBiodataSaved,
      acceptance,
      PortalCharges,
      accreditationFee,
      changeofDepartmentFee,
    } = this.state;

    return (
      <Dialog
        open={this.state.paymentOptionDialog}
        onClose={() => {
          this.setState({ paymentOptionDialog: false });
        }}
        maxWidth="md"
        fullWidth
      >
        <DialogContent>
          <Box mt={1} mb={4}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography
                variant="h5"
                className={classes.sectionTitle}
                gutterBottom
              >
                Payment Options
              </Typography>

              {/* Close button */}
              <IconButton
                onClick={() => this.setState({ paymentOptionDialog: false })}
                aria-label="Close"
              >
                <CloseIcon />
              </IconButton>
            </Box>
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              minWidth={320}
            >
              <Box mb={3} alignSelf="stretch">
                {IsBiodataSaved && acceptance < 1 ? (
                  <>
                    <div style={{ marginBottom: 4 }}>
                      Acceptance Fee:{" "}
                      {`₦ ${this.formatCurrency(
                        this.state.portalCharges?.AcceptanceFees
                      )}`}
                    </div>
                    <div style={{ marginBottom: 4 }}>
                      Portal Charge:{" "}
                      {`₦ ${this.formatCurrency(
                        this.state.portalCharges?.PortalCharges
                      )}`}
                    </div>
                    <div style={{ fontWeight: 600 }}>
                      Total Charge:{" "}
                      {`₦ ${this.formatCurrency(
                        this.state.portalCharges?.TotalAmount
                      )}`}{" "}
                    </div>
                  </>
                ) : IsBiodataSaved && acceptance === 1 ? (
                  <>
                    <div style={{ marginBottom: 4 }}>
                      Accreditation Fee:{" "}
                      {`₦${this.formatCurrency(
                        this.state.accreditationFee?.AccreditationFees
                      )}`}
                    </div>
                    <div style={{ marginBottom: 4 }}>
                      School Fee:{" "}
                      {`₦${this.formatCurrency(
                        this.state.accreditationFee?.SchoolFees
                      )}`}
                    </div>
                    <div style={{ fontWeight: 600 }}>
                      Total Charge:{" "}
                      {`₦${this.formatCurrency(
                        this.state.accreditationFee?.Total
                      )}`}{" "}
                    </div>
                  </>
                )  : IsBiodataSaved && acceptance === 5 ? (
                  <>
                    
                    <div style={{ marginBottom: 4, fontWeight: 600 }}>
                      Change of Department Fee:{" "}
                      {`₦${this.formatCurrency(
                        this.state.changeofDepartmentFee?.Amount
                      )}`}
                    </div>
                  
                  </>
                ) : null}
              </Box>
            </Box>
            <Typography variant="body1" paragraph style={{ marginBottom: 24 }}>
              Choose your preferred payment method to continue:
            </Typography>

            <Grid
              container
              spacing={3}
              justifyContent="center"
              style={{ marginBottom: 32 }}
            >
              <Grid item xs={12} sm={6} md={5}>
                <Card
                  className={classes.paymentOption}
                  onClick={this.initiateMonnify}
                  style={{
                    padding: 16,
                    cursor: "pointer",
                    height: 120,
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Box display="flex" alignItems="center" width="100%">
                    <img
                      src={monnify}
                      alt="Monnify"
                      width="80px"
                      style={{ marginRight: 16 }}
                    />
                    <Box>
                      <Typography variant="h6" style={{ fontWeight: 600 }}>
                        Pay with Monnify
                      </Typography>
                      <Typography variant="body2" color="textSecondary">
                        Secure payment with bank transfer, card or USSD
                      </Typography>
                    </Box>
                  </Box>
                </Card>
              </Grid>
              <Grid item xs={12} sm={6} md={5}>
                <Card
                  className={classes.paymentOption}
                  onClick={this.initiateNomba}
                  style={{
                    padding: 16,
                    cursor: "pointer",
                    height: 120,
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Box display="flex" alignItems="center" width="100%">
                    <img
                      src={nomba}
                      alt="nomba"
                      width="90px"
                      style={{ marginRight: 16 }}
                    />
                    <Box>
                      <Typography variant="h6" style={{ fontWeight: 600 }}>
                        Pay with Nomba
                      </Typography>
                      <Typography variant="body2" color="textSecondary">
                        Payment via Nomba platform
                      </Typography>
                    </Box>
                  </Box>
                </Card>
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
      </Dialog>
    );
  }
  renderPaymentOptionsSkeleton = () => {
    const { classes } = this.props;

    return (
      <Box mt={4}>
        <Skeleton
          className={classes.skeletonPulse}
          variant="text"
          width="30%"
          height={40}
          style={{ marginBottom: 24 }}
        />
        <Skeleton
          className={classes.skeletonPulse}
          variant="text"
          width="70%"
          height={24}
          style={{ marginBottom: 16 }}
        />

        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Card className={classes.paymentOption}>
              <Box display="flex" alignItems="center">
                <Skeleton
                  className={classes.skeletonPulse}
                  variant="rect"
                  width={80}
                  height={80}
                  style={{ marginRight: 16 }}
                />
                <Box>
                  <Skeleton
                    className={classes.skeletonPulse}
                    variant="text"
                    width={150}
                    height={28}
                  />
                  <Skeleton
                    className={classes.skeletonPulse}
                    variant="text"
                    width={200}
                    height={20}
                  />
                </Box>
              </Box>
            </Card>
          </Grid>
          <Grid item xs={12} md={6}>
            <Card className={classes.paymentOption}>
              <Box display="flex" alignItems="center">
                <Skeleton
                  className={classes.skeletonPulse}
                  variant="rect"
                  width={80}
                  height={80}
                  style={{ marginRight: 16 }}
                />
                <Box>
                  <Skeleton
                    className={classes.skeletonPulse}
                    variant="text"
                    width={150}
                    height={28}
                  />
                  <Skeleton
                    className={classes.skeletonPulse}
                    variant="text"
                    width={200}
                    height={20}
                  />
                </Box>
              </Box>
            </Card>
          </Grid>
        </Grid>
      </Box>
    );
  };

  renderPaymentStatusOverlay() {
    const { paymentStatusLoader } = this.state;

    if (!paymentStatusLoader) return null;

    return (
      <div
        style={{
          width: "100%",
          height: "75vh",
          backgroundColor: "rgba(255, 255, 255, 0.98)",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          transform: "translate(0, 0)", // Reset any transforms
          inset: 0,
          alignItems: "center",
          zIndex: 10000, // Higher than any other z-index in your app
          backdropFilter: "blur(2px)", // Modern browsers blur effect
        }}
      >
        <div
          style={{ textAlign: "center", maxWidth: "400px", padding: "20px" }}
        >
          <CircularProgress
            size={60}
            color="primary"
            thickness={4}
            style={{ marginBottom: "24px" }}
          />

          <Typography
            variant="h5"
            style={{
              marginBottom: "16px",
              color: "#1976d2",
              fontWeight: 600,
            }}
          >
            Processing Payment
          </Typography>

          <Typography
            variant="body1"
            color="textSecondary"
            style={{
              marginBottom: "12px",
              lineHeight: 1.5,
            }}
          >
            We're verifying your payment status. This may take a few moments.
          </Typography>

          <Typography
            variant="body2"
            color="textSecondary"
            style={{
              fontStyle: "italic",
              opacity: 0.8,
            }}
          >
            Please do not close or refresh this page.
          </Typography>
        </div>
      </div>
    );
  }

  render() {
    const { Provider } = DashboardContext;
    const { match, width, authUser } = this.props;
    const {
      loader,
      admissionLetterDrawer,
      paymentDialog,
      message,
      transactionStatus,
      statusResponse,
      paymentStatus,
      remitaResponse,
      paymentType,
      activeDraw,
      applicationSlip,
      showWelcomeModal,
      downloadDoc,
      isResultSaved,
      IsOlevelSaved,
      IsBiodataSaved,
      RegComplete,
      IsPasswdChgd,
      IsDocUpload,
      JambRegNo,
      AdmissionStatus,
      acceptance,
      applicantData,
      olevel,
      CourseofStudy,
      acceptPayment,
      RegStatus,
      paymentStatusLoader,
      applicantFormShow,
      screeningExerciseDiag,
      provisionalAdmissionLetterDiag,
      portalCharges,
      accreditationFee,
      changeofDepartmentFee,
      FeeLoader,
      WaecVerify,
      DeptID
    } = this.state;

    const urlParams = new URLSearchParams(window.location.search);
    const transactionReference = urlParams.get("paymentReference");

    const renderRow = (label, value, isTotal = false) => (
      <Grid container alignItems="center" justifyContent="space-between" mb={1}>
        <Typography
          variant={isTotal ? "h6" : "subtitle1"}
          color={isTotal ? "primary" : "textPrimary"}
        >
          <strong>{label}</strong>
        </Typography>
        <Typography
          variant={isTotal ? "h6" : "subtitle1"}
          color={isTotal ? "primary" : "textPrimary"}
        >
          {value}
        </Typography>
      </Grid>
    );

    return (
      <Provider>
        <div className="app-wrapper">
          <div className="dashboard animated slideInUpTiny animation-duration-3">
            <ContainerHeader
              match={match}
              title={<IntlMessages id="sidebar.dashboard" />}
            />
            {paymentStatusLoader &&
              this.renderPaymentStatusOverlay()
            }

            {(loader || FeeLoader) && (
              // Show skeleton loaders when loading
              <div>
                {this.renderStepProgressSkeleton()}
                {this.renderCurrentStepCardSkeleton()}

                {/* Conditionally show payment options skeleton if needed */}
                {IsBiodataSaved && this.renderPaymentOptionsSkeleton()}

                {/* Show documents skeleton if needed */}
                {this.state.acceptance === 4 &&
                  this.renderDocumentsSectionSkeleton()}
              </div>
            )}

            {!paymentStatusLoader && !loader && !FeeLoader &&
              // Show actual content when not loading
              (<Suspense
                fallback={
                  <div
                    className="loader-view"
                    style={{
                      height:
                        width >= 1200
                          ? "calc(100vh - 265px)"
                          : "calc(100vh - 245px)",
                    }}
                  >
                    <CircularProgress />
                  </div>
                }
              >
                {this.renderPaymentStatusOverlay()}
                {/* Render the enhanced progress tracker */}
                {this.renderStepProgress()}

                {/* Render the current step card with actions */}
                {this.renderCurrentStepCard()}

                {/* Conditionally render payment options if at that step */}
                {IsBiodataSaved && this.renderPaymentOptions()}
                {/* {this.state.acceptance === 1 && this.renderPaymentOptions()} */}

                {/* Render documents section for admitted students */}
                {this.state.acceptance === 4 && this.renderDocumentsSection()}
              </Suspense>
              )}
          </div>
        </div>

        <NotificationContainer />

        <Dialog
          open={this.state.warning}
          TransitionComponent={Transition}
          keepMounted
          onClose={this.onCancelWarning}
          aria-labelledby="confirm-reg-title"
          aria-describedby="confirm-reg-description"
        >
          <DialogTitle>
            <Box display="flex" alignItems="center" gap={3}>
              <WarningRounded
                style={{ color: "#ff9800", fontSize: "3rem" }}
                color="warning"
              />
              <Typography
                variant="h5"
                component="span"
                style={{ color: "#f57c00" }}
                fontWeight="bold"
              >
                Are You Sure?
              </Typography>
            </Box>
          </DialogTitle>

          <DialogContent>
            <DialogContentText id="confirm-reg-description">
              Kindly review your application as you won't be able to change your
              details after you submit.
            </DialogContentText>
          </DialogContent>

          <DialogActions>
            <Button
              onClick={this.onCancelWarning}
              variant="outlined"
              color="inherit"
            >
              Cancel
            </Button>
            <Button
              onClick={this.handleReg}
              variant="contained"
              color="primary"
            >
              Submit
            </Button>
          </DialogActions>
        </Dialog>
        {/* === === === End of Confirm Reg Dialog === === === */}
        {/* === === === Start of Change Password Dialog === === === */}
        <Dialog
          open={this.state.pwdDialog}
          onClose={(event) => {
            this.setState({ pwdDialog: true });
          }}
        >
          <DialogTitle>{"Welcome!"}</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Login successful! You are required to change your default
              password.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            {/* <Button onClick={this.handleRequestClose} color="secondary">
                        Disagree
                      </Button> */}
            <Button onClick={this.handleRequestClose} color="primary">
              Proceed
            </Button>
          </DialogActions>
        </Dialog>

        {/* Admission Letter Dialog */}
        <Dialog
          fullScreen
          open={admissionLetterDrawer}
          onClose={this.toggleDrawer("admissionLetterDrawer", false)}
          TransitionComponent={Transition}
        >
          <AppBar
            className="position-relative"
            style={{ backgroundColor: "#1E90FF" }}
          >
            <Toolbar>
              <IconButton
                style={{ color: "white" }}
                onClick={this.toggleDrawer("admissionLetterDrawer", false)}
                aria-label="Close"
              >
                <CloseIcon />
              </IconButton>
              <Typography
                variant="h5"
                style={{
                  flex: 1,
                  color: "white",
                }}
              >
                {downloadDoc.find((doc) => doc.formId === activeDraw)?.formName}
              </Typography>
              <GenericPdfDownloader
                downloadFileName="AdmissionLetterPdf"
                rootElementId="content"
              />
            </Toolbar>
          </AppBar>
          <Suspense
            fallback={
              <div
                className="loader-view"
                style={{
                  height:
                    width >= 1200
                      ? "calc(100vh - 265px)"
                      : "calc(100vh - 245px)",
                }}
              >
                <CircularProgress />
              </div>
            }
          >
            {activeDraw === downloadDoc[0]?.formId && (
              <div id="content">
                <AdmLetter applicant={authUser} applicantData={applicantData} />
                {/* <AdmLetterPg2 applicant={authUser} /> */}
              </div>
              // <FullAdmissionLetter applicant={authUser} />
            )}
            {activeDraw === downloadDoc[1]?.formId && (
              <PaymentReceipt
                rrrResponse={acceptPayment}
                token={this.props?.authUser?.token}
                applicantId={this?.props?.authUser}
              />
            )}
            {/* {activeDraw === downloadDoc[2]?.formId && (
                      <PostUmtePayRec applicant={applicantData} />
                    )} */}
            {activeDraw === downloadDoc[2]?.formId && (
              <SchoolFeeChart applicant={authUser} />
            )}
            {activeDraw === downloadDoc[3]?.formId && (
              <Acceptance applicant={authUser} />
            )}
            {/* {activeDraw === downloadDoc[4]?.formId && (
                      <SiwesLetter applicant={authUser} />
                    )} */}
          </Suspense>
        </Dialog>

        {/* Application Slip Dialog */}
        <Dialog
          fullScreen
          open={applicationSlip}
          onClose={this.toggleDrawer("applicationSlip", false)}
          TransitionComponent={Transition}
        >
          <AppBar
            className="position-relative"
            style={{ backgroundColor: "#1E90FF" }}
          >
            <Toolbar>
              <IconButton
                style={{ color: "white" }}
                onClick={this.toggleDrawer("applicationSlip", false)}
                aria-label="Close"
              >
                <CloseIcon />
              </IconButton>
              <Typography
                variant="h5"
                style={{
                  flex: 1,
                  color: "white",
                }}
              >
                {downloadDoc.find((doc) => doc.formId === activeDraw)?.formName}
              </Typography>
              <GenericPdfDownloader
                downloadFileName="ApplicationSlipPdf"
                rootElementId="content"
              />
            </Toolbar>
          </AppBar>
          <ApplicantForm applicant={applicantData} olevel={olevel} />
        </Dialog>

        {/* === === === Screening Dialog === === === */}
        <Dialog
          fullScreen
          open={screeningExerciseDiag}
          onClose={this.toggleDrawer("screeningExerciseDiag", false)}
          TransitionComponent={Transition}
        >
          <AppBar
            className="position-relative"
            style={{ backgroundColor: "#1E90FF" }}
          >
            <Toolbar>
              <IconButton
                style={{ color: "white" }}
                onClick={this.toggleDrawer("screeningExerciseDiag", false)}
                aria-label="Close"
              >
                <CloseIcon />
              </IconButton>
              <Typography
                variant="h5"
                style={{
                  flex: 1,
                  color: "white",
                }}
              >
                {downloadDoc.find((doc) => doc.formId === activeDraw)?.formName}
              </Typography>
              <GenericPdfDownloader
                downloadFileName="AcceptanceLetterPdf"
                rootElementId="content"
              />
            </Toolbar>
          </AppBar>
          <ScreeningExercise applicant={applicantData} />
        </Dialog>
        
        {/* === === === Provisional Admission Letter Dialog === === === */}
        <Dialog
          fullScreen
          open={provisionalAdmissionLetterDiag}
          onClose={this.toggleDrawer("provisionalAdmissionLetterDiag", false)}
          TransitionComponent={Transition}
        >
          <AppBar
            className="position-relative"
            style={{ backgroundColor: "#1E90FF" }}
          >
            <Toolbar>
              <IconButton
                style={{ color: "white" }}
                onClick={this.toggleDrawer("provisionalAdmissionLetterDiag", false)}
                aria-label="Close"
              >
                <CloseIcon />
              </IconButton>
              <Typography
                variant="h5"
                style={{
                  flex: 1,
                  color: "white",
                }}
              >
                Provisional Admission Letter
              </Typography>
              <GenericPdfDownloader
                downloadFileName="Provisional Admission Letter"
                rootElementId="content"
              />
            </Toolbar>
          </AppBar>
          <Suspense
            fallback={
              <div
                className="loader-view"
                style={{
                  height:
                    width >= 1200
                      ? "calc(100vh - 265px)"
                      : "calc(100vh - 245px)",
                }}
              >
                <CircularProgress />
              </div>
            }
          >
            <DSTProvisionalAdmissionLetter applicant={authUser} applicantData={applicantData} />
          </Suspense>
        </Dialog>

        {/* === === === Payment Dialog === === === */}
        <Dialog
          open={paymentDialog}
          fullWidth={true}
          TransitionComponent={Slide}
          onClose={(event) => this.closePayment(false)}
        >
          <DialogTitle
            disableTypography
            className="d-flex p-0"
            style={{ justifyContent: "flex-end" }}
          >
            <IconButton onClick={(event) => this.closePayment(false)}>
              <Cancel />
            </IconButton>
          </DialogTitle>
          <Suspense
            fallback={
              <div
                className="loader-view"
                style={{
                  height:
                    width >= 1200
                      ? "calc(100vh - 265px)"
                      : "calc(100vh - 245px)",
                }}
              >
                <CircularProgress />
              </div>
            }
          >
            <DialogContent
              style={{ display: "flex", justifyContent: "center" }}
            >
              <Checkout
                payeeInfo={remitaResponse}
                stateChange={this.closePayment}
                paymentType={paymentType}
              />
            </DialogContent>
          </Suspense>
        </Dialog>

        {/* === === === Payment status === === === */}

        <Dialog
          open={paymentStatus}
          fullWidth={true}
          TransitionComponent={Slide}
          onClose={(event) => this.closePaymentStatus(false)}
        >
          <DialogTitle
            disableTypography
            className="d-flex p-0"
            style={{ justifyContent: "flex-end" }}
          >
            <IconButton onClick={(event) => this.closePaymentStatus(false)}>
              <Cancel />
            </IconButton>
          </DialogTitle>
          <Suspense
            fallback={
              <div
                className="loader-view"
                style={{
                  height:
                    width >= 1200
                      ? "calc(100vh - 265px)"
                      : "calc(100vh - 245px)",
                }}
              >
                <CircularProgress />
              </div>
            }
          >
            <DialogContent
              style={{ display: "flex", justifyContent: "center" }}
            >
              <div className="text-center">
                {transactionReference ? (
                  <div style={{ marginBottom: "20px" }}>
                    <img
                      className="isw-pay-logo w-8 h-8"
                      src={monnify}
                      alt="monnify"
                      width="150px"
                    />
                  </div>
                ) : (
                  <div style={{ marginBottom: "20px" }}>
                    <img
                      className="isw-pay-logo w-8 h-8"
                      src={nomba}
                      alt="nomba"
                      width="150px"
                    />
                  </div>
                )}

                <h4>{message}</h4>
                <h6>Transaction Reference: {statusResponse?.TransactionRef}</h6>

                {this.state.transactionStatus === "success" && (
                  <div>
                    <strong>
                      <h6>What Next !</h6>
                    </strong>
                    {acceptance == 1 && 'Proceed to Pay School Fees.'}
                  </div>
                )}
              </div>
            </DialogContent>
          </Suspense>

          <button
            type="button"
            width="50px"
            className="btn btn-primary"
            onClick={(event) => this.closePaymentStatus(false)}
          >
            OK
          </button>
        </Dialog>
        {/* )} */}

        {/* data mangement fee Payment Dialog */}
        <Dialog
          open={
            !!(
              this.state.verificationPayment &&
              this.state.verificationPayment.open
            )
          }
          onClose={() => this.setState({ verificationPayment: null })}
        >
          <DialogTitle disableTypography>
            <Typography
              variant="h6"
              align="center"
              style={{ width: "100%", fontWeight: 600 }}
            >
              Pay Data Management Fee
            </Typography>
          </DialogTitle>
          <DialogContent>
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              minWidth={320}
            >
              <Box mb={3} alignSelf="stretch">
                {renderRow(
                  "Data Management Fee:",
                  `₦${this.state.verificationPayment?.VerificationFee}`
                )}
                {renderRow(
                  "Number of O'level Sittings:",
                  this.state.verificationPayment?.NumberOfSittings
                )}
                {renderRow(
                  "Total to Pay:",
                  `₦${this.state.verificationPayment?.TotalAmountToPay}`,
                  true
                )}
                {/* <Divider/> */}
              </Box>
              <Box
                display="flex"
                flexDirection="column"
                gap={2}
                width="100%"
                maxWidth={350}
              >
                <Button
                  onClick={this.payVerificationNomba}
                  variant="contained"
                  color="primary"
                  size="small"
                  startIcon={
                    <img
                      src={nombaWhite}
                      alt="Nomba"
                      width={80}
                      style={{ borderRadius: 4 }}
                    />
                  }
                  style={{ marginBottom: 12, fontWeight: 600 }}
                  fullWidth
                >
                  Pay with Nomba
                </Button>
                <Button
                  onClick={this.payVerificationMonnify}
                  variant="contained"
                  color="primary"
                  size="small"
                  startIcon={
                    <img
                      src={monnifyWhite}
                      alt="Monnify"
                      width={80}
                      // height={50}
                      style={{ borderRadius: 4 }}
                    />
                  }
                  style={{ marginBottom: 12, fontWeight: 600 }}
                  fullWidth
                >
                  Pay with Monnify
                </Button>

                <Button
                  onClick={this.payVerificationEtranzact}
                  variant="contained"
                  color="primary"
                  size="small"
                  startIcon={
                    <img
                      src={xpress}
                      alt="Xpress"
                      width={29}
                      style={{ borderRadius: 4 }}
                    />
                  }
                  style={{ fontWeight: 600 }}
                  fullWidth
                >
                  Pay with XPRESS
                </Button>
              </Box>
            </Box>
          </DialogContent>
        </Dialog>
      </Provider>
    );
  }
}

// Keep your existing mapStateToProps and connect
const mapStateToProps = ({ auth }) => {
  const authUser = auth.applicantUser;
  const { userMode } = auth;
  return { authUser, userMode };
};

export default connect(mapStateToProps, { regStatus, userSignOut, updateApplicantData })(
  withStyles(styles)(Dashboard)
);
export { DashboardContext };
